import type {
  GridFilterItem,
  GridValidRowModel,
} from "@mui/x-data-grid-premium";
import type { SelectSearchField } from "src/components/Form/Form.types.ts";
import type { SelectLabelProp } from "src/system/system.types.ts";
import { getSelectSearchField } from "src/system/getSelectSearchField.ts";

export const getSelectFilters = <
  Resource extends GridValidRowModel = GridValidRowModel,
>({
  searchField,
  searchValue,
  labelProp,
}: {
  searchValue?: string;
  searchField?: SelectSearchField;
  labelProp?: SelectLabelProp<Resource>;
}): GridFilterItem[] => {
  if (isFilterFieldArrayOfObjects(searchField)) {
    return searchField.map((filter) => ({
      field: filter.field,
      operator: filter.operator,
      value: filter.value ?? searchValue,
    }));
  }
  if (Array.isArray(searchField)) {
    return searchField.map((field) => ({
      field: field,
      operator: "partial",
      value: searchValue,
    }));
  }
  return [
    {
      field: getSelectSearchField({
        searchField: searchField,
        labelProp,
      }),
      operator: "partial",
      value: searchValue,
    },
  ];
};

function isFilterFieldArrayOfObjects(
  value: unknown,
): value is GridFilterItem[] {
  return Array.isArray(value) && typeof value[0] === "object";
}
